export const USER_TYPES = [
    // {
    //     label: "Host (Trip Captain)",
    //     value: "host"
    // },
    {
        label: "Merchant (Trip Organiser)",
        value: "merchant"
    }
]